<template>
  <v-container fluid>
    <v-row align="center" class="mr-0">
      <h1>Template</h1>
      <v-spacer />
      <v-btn
        color="primary"
        @click="openNewDialog"
      >
        <v-icon left dark>add</v-icon>
        Add new
      </v-btn>
    </v-row>
    <v-layout row>
      <v-flex xs3>
        <v-subheader>Ad body:</v-subheader>
      </v-flex>
      <v-flex xs6>
        <v-textarea
          outline
          single-line
          hide-details
          v-model="template.body"
          class="select-bordered"
        />
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex xs3>
        <v-subheader>Headline:</v-subheader>
      </v-flex>
      <v-flex xs6>
        <v-text-field
          v-model="template.headline"
          outline
          single-line
          hide-details
          class="select-bordered"
        />
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex xs3>
        <v-subheader>Link Description:</v-subheader>
      </v-flex>
      <v-flex xs6>
        <v-text-field
          v-model="template.link_description"
          outline
          single-line
          hide-details
          class="select-bordered"
        />
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex xs3>
        <v-subheader>URL:</v-subheader>
      </v-flex>
      <v-flex xs6>
        <v-text-field
          v-model="template.url"
          outline
          single-line
          hide-details
          class="select-bordered"
        />
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex xs3>
        <v-subheader>Image:</v-subheader>
      </v-flex>
      <v-flex xs6>
        <v-text-field
          v-model="template.image"
          outline
          single-line
          hide-details
          class="select-bordered"
        />
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex xs3>
        <v-subheader>Output:</v-subheader>
      </v-flex>
      <v-flex xs6>
        <div v-for="(ad, index) in eventsToAds">
          <p>
            {{ad.body}}
          </p>
          <p>
            {{ad.image}}
          </p>
          <p>
            {{ad.headline}}
          </p>
          <p>
            {{ad.link_description}}
          </p>
          <hr />
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import moment from 'moment'
  import { mapGetters } from 'vuex'
  export default {
    name: 'AdminComponent',
    components: {
    },
    data () {
      return {
        template: {
          body: "Hi {city}! This {start_date|ddd} --\n{description}",
          headline: "{title}",
          link_description: "Come join us this {start_date|ddd, MMM DD}!",
          // parameters: "utm_source={{site_source_name}}&utm_medium={{placement}}&utm_campaign={{campaign.name}}_{adset.name}}&utm_content={{ad.id}}_{{ad.name}}",
          image: "rally-{city}"
        },
        events: [
          {"start_date": "08/18/2020",
          city: "Brooklyn",
          state: "New York",
          title: "Joe Biden Wisconsin Phone Bank",
          description: "We'll be phone banking to undecided voters in Wisconsin."
        },
          {"start_date": "08/19/2020",
          city: "Boston",
          state: "Massachusetts",
          title: "Joe Biden Arizona Phone Bank",
          description: "We'll be phone banking to undecided voters in Arizona."}]
      }
    },
    computed: {
      ...mapGetters({
        user: 'getCurrentUser',
        advertisers: 'getAdvertisers'
      }),
      clients () {
        if (!this.user || !this.advertisers.length) return []
        const ids = this.user.firebaseAccount.advertisers.map(a => a.id)
        return this.advertisers.filter(advertiser => ids.find(id => id === advertiser.id)).map(a => {
          return {
            id: a.id,
            name: a.data.name,
            type: a.data.type,
            status: 'Active',
            location: a.data.political.state
          }
        })
      },
      selectedClient () {
        return this.advertisers.find(a => a.id === this.selectedClientId)
      },
      showTable () {
        return this.clients.length > 1 && !this.selectedClient
      },
      templatePreview () {
        let template = this.ad_body + '\n' +
        this.ad_image + '\n' +
        this.ad_headline + '\n' +
        this.ad_link_description + '\n-------\n'

        let tranformStr = el => {
          return template.replace('{start_date}', el.start_date).replace('{city}', el.city).replace('{state}', el.state)
        }

        let output = ""

        let result = this.events.map(tranformStr)
        for (let i = 0; i < result.length; i++) {
          output += result[i]
        }

        return output
      },
      eventsToAds () {
        let output = []
        let ev

        for (ev of this.events) {
          output.push({
            body: this.eventTransform(this.template.body, ev),
            headline: this.eventTransform(this.template.headline, ev),
            link_description: this.eventTransform(this.template.link_description, ev),
            // parameters: "utm_source={{site_source_name}}&utm_medium={{placement}}&utm_campaign={{campaign.name}}_{adset.name}}&utm_content={{ad.id}}_{{ad.name}}",
            image: this.eventTransform(this.template.image, ev)
          })
        }

        return output
      }
    },
    methods: {
      setEditedClient (id) {
        this.selectedClientId = id
      },
      returnToClientsTable () {
        this.selectedClientId = null
      },
      conditionalTransform (template, ev) {
        let re = /{if (start_date|end_date|city|description)\|[^}]*}[^}]*}/gm

        let arr = template.split(re)

        for (let i = 0; i < arr.length; i++) {
          if ((arr[i] === "start_date") || (arr[i] === "end_date")) {
            arr[i] = moment(ev[arr[i]]).format(arr[i + 1])
            arr[i + 1] = ""
          }
        }
        return arr.join('').replace('{city}', ev.city).replace('{state}', ev.state).replace('{description}', ev.description).replace('{title}', ev.title)
      },
      eventTransform (template, ev) {
        let re = /{(start_date|end_date)\|([^}]*)}/gm

        let arr = template.split(re)

        for (let i = 0; i < arr.length; i++) {
          if ((arr[i] === "start_date") || (arr[i] === "end_date")) {
            arr[i] = moment(ev[arr[i]]).format(arr[i + 1])
            arr[i + 1] = ""
          }
        }
        return arr.join('').replace('{city}', ev.city).replace('{state}', ev.state).replace('{description}', ev.description).replace('{title}', ev.title)
      }
    },
    watch: {
      user: {
        handler (val) {
          if (val && val.firebaseAccount.advertisers.length === 1) {
            this.selectedClientId = val.firebaseAccount.selectedAdvertiser
          } else if (val.firebaseAccount.advertisers.length > 1) {
            this.selectedClientId = val.firebaseAccount.selectedAdvertiser
            this.cancel = true
          }
        },
        immediate: true,
        deep: true
      }
    }
  }
</script>
